import { render, staticRenderFns } from "./RmpDigitalSignatureCertificateLoader.vue?vue&type=template&id=1bba6ba8&scoped=true"
import script from "./RmpDigitalSignatureCertificateLoader.vue?vue&type=script&lang=js"
export * from "./RmpDigitalSignatureCertificateLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bba6ba8",
  null
  
)

export default component.exports